import { render } from "./interview.vue?vue&type=template&id=363a986f"
import script from "./interview.vue?vue&type=script&lang=js"
export * from "./interview.vue?vue&type=script&lang=js"

import "./interview.vue?vue&type=style&index=0&id=363a986f&lang=scss"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lidu/礼度管理后台-管理员端【生产】/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__